export default __webpack_public_path__ + "static/media/5.dfe9ffc7.jpg";